



























































import {
  Vue,
  Component
} from "@/shared/vuepack";
import * as routes from "@/employee/route-names";
import { formatCurrency } from "@/shared/currency";
import { useUserStore } from "@/shared/store/user";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";

@Component
export default class HealthcareExpenseNavigation extends Vue {
  userStore = useUserStore();
  custodianSettingsStore = useCustodianSettingsStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();

  routes = routes;
  formatCurrency = formatCurrency;
  activeTab = null;

  mounted (): void {
    this.expenseBalanceSummaryStore.loadState();
    this.userStore.loadPartnerSettings();
    this.activeTab = this.$route.name;
  }

  navigationClicked (pathName: string) {
    this.activeTab = pathName;
    this.$emit("navigation-tab-item-clicked", {
      name: this.$route.name,
      path: pathName,
    });
  }

  get reimbursedSubtitle () {
    return "YTD";
  }
}
